import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-secondary-50">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Shipping</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">CSSBuy Shipping Guide</h1>
            <p className="text-foreground-600 text-lg">Understand shipping costs, methods, weight calculations, and delivery expectations.</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Shipping Methods</h2>
              <p className="text-foreground-700 mb-2">CSSBuy typically offers multiple shipping options ranging from economy to express. Common methods include postal services, courier services, and dedicated lines. Each method differs in speed, cost, and tracking capabilities.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Weight and Volumetric Weight</h2>
              <p className="text-foreground-700 mb-2">Shipping costs are calculated based on either actual weight or volumetric weight, whichever is higher. Volumetric weight considers the package dimensions, so large but lightweight items can cost more to ship.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Insurance and Tracking</h2>
              <p className="text-foreground-700 mb-2">Consider adding insurance for valuable items. Tracking availability depends on the shipping method chosen. Express methods usually offer detailed tracking, while economy options may have limited tracking.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Delivery Times</h2>
              <p className="text-foreground-700 mb-2">Delivery times vary significantly by destination, shipping method, and customs processing. Express shipping can take 5-15 days, while economy options may take 2-8 weeks or longer.</p>
            </div>
            <div className="bg-secondary-50 rounded-xl p-6 border border-secondary-200/50">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">Important Note</h2>
              <p className="text-foreground-700 text-sm">Shipping costs and delivery times change frequently. Always check current rates through CSSBuy before confirming your shipment. Customs fees and import duties may apply depending on your country.</p>
            </div>
            <div className="text-center">
              <a href="/" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                Back to Homepage
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}